import { render, staticRenderFns } from "./VolumeDiscountTierEditor.vue?vue&type=template&id=80457fae&scoped=true&"
import script from "./VolumeDiscountTierEditor.vue?vue&type=script&lang=js&"
export * from "./VolumeDiscountTierEditor.vue?vue&type=script&lang=js&"
import style0 from "./VolumeDiscountTierEditor.vue?vue&type=style&index=0&id=80457fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80457fae",
  null
  
)

export default component.exports